import { Feedback } from './components/feedback/feedback';
export default Feedback;
